import React from "react";
import {
  Box,
  Text,
  Heading,
  HStack,
  IconButton,
  Badge,
  Flex,
  VStack,
} from "@chakra-ui/react";
import { FaTrain, FaHeart, FaPen } from "react-icons/fa";
import Translate from "../../../components/LanguageTranslation/Translate";
import { useCurrency } from "../../CurrencyExchange/CurrencyContext";

const TrainTicketsCard = ({ trainTicket, manual, handleDelete, handleEdit }) => {
  const { convertCurrency, currency } = useCurrency();
  if (!trainTicket) return null;

  // Safely handle missing price data
  const priceAmount = trainTicket.price?.amount ?? 0;
  const priceCurrency = trainTicket.price?.currency ?? "USD";

  const convertedPrice = convertCurrency(priceAmount, priceCurrency);

  // Format ISO date to readable
  const formatDate = (iso) => (iso ? new Date(iso).toLocaleDateString() : "—");

  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      cursor="pointer"
      p={2}
    >
      <VStack
        p={2}
        borderRadius="xl"
        alignItems="flex-start"
        w="100%"
        spacing={3}
        bg="white"
        h="100%"
      >
        {/* Price and Company Info */}
        <Box width="100%" position="relative">
          <HStack spacing={1}>
            <FaTrain size={40} style={{ marginRight: 16 }} />
            <Heading size="sm" mb={0} mr={2} noOfLines={1}>
              <Translate text={trainTicket.train_company || "Train Company"} />
            </Heading>
            <IconButton
              aria-label="Edit train ticket"
              icon={<FaPen />}
              size="sm"
              bg="none"
              _hover={{ bg: "gray.100" }}
              onClick={(e) => {
                e.stopPropagation();
                handleEdit(trainTicket);
              }}
            />
          </HStack>
          <Badge
            bg="none"
            color="#02FB45"
            border="1px solid"
            borderColor="#02FB45"
            borderRadius="md"
            textTransform="capitalize"
            fontSize="xs"
            fontWeight="bold"
            mb={2}
            mt={2}
          >
            <Translate text="Train Ticket" />
          </Badge>
          <Text fontWeight="bold" fontSize="md" mt={2} mb={2}>
            <Translate text="Live price:" /> {currency} {convertedPrice}
          </Text>
          <IconButton
            aria-label="Add to favorites"
            icon={<FaHeart />}
            size="md"
            bg="none"
            _hover={{ bg: "none" }}
            position="absolute"
            top="0px"
            right="0px"
            borderRadius="full"
            color="red.500"
            onClick={handleDelete}
          />
        </Box>
        <HStack
          justify="space-between"
          width="full"
          spacing={0}
          bg="blackAlpha.50"
          padding={2}
          borderRadius="xl"
        >
          <Flex
            justify="space-between"
            mt={2}
            mb={2}
            width="100%"
            align="center"
          >
            <Text fontSize="sm" mb={0}>
              {trainTicket.origin_station}
            </Text>
            <Text fontSize="lg" mx={2} mb={0}>
              ➔
            </Text>
            <Text fontSize="sm" mb={0}>
              {trainTicket.destination_station}
            </Text>
          </Flex>
        </HStack>
        <Flex justify="space-between" mb={2} width="100%">
          <Text fontSize="sm">
            <Translate text="Departure:" />{" "}
            {formatDate(trainTicket.departure_date)}
          </Text>
          <Text fontSize="sm">
            <Translate text="Arrival:" /> {formatDate(trainTicket.arrival_date)}
          </Text>
        </Flex>
      </VStack>
    </Box>
  );
};

export default TrainTicketsCard;
